var _style, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWhite57(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-white-57_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".menu-white-57_svg__st8{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 217,
    r: 32.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 512,
    r: 32.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 807,
    r: 32.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983 544.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5zM983 839.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5zM983 249.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite57);
export default ForwardRef;